export default async ({ store, redirect }) => {
  await store.dispatch('auth/load');
  if (!store.state.auth.isAuthenticated) {
    store.dispatch('notifications/stopListenToNotifications');
    return redirect('/login');
  }
};
